/**
 * Info
 *
 * @description - A class that represents an info model for the library, containing the following properties:
 * 					- VERSION: The version of the library.
 * 					- AUTHOR: The author of the library.
 * 					- LICENSE: The license of the library.
 * 					- HOMEPAGE: The homepage of the library.
 * 					- REPOSITORY: The repository of the library.
 */
export default class Info {
    /**
     * Version  of info
     */
    VERSION = "2.0.1";
    /**
     * Author  of info
     */
    AUTHOR = "Jonas Pfalzgraf";
    /**
     * License  of info
     */
    LICENSE = "MIT";
    /**
     * Repository  of info
     */
    REPOSITORY = "git+https://github.com/JosunLP/simple-toast-messages.git";
    /**
     * Homepage  of info
     */
    HOMEPAGE = "https://github.com/JosunLP/simple-toast-messages#readme";
    /**
     * Gets info
     * @returns
     *
     * @example
     * ```
     * getInfo()
     * ```
     */
    getInfo() {
        return {
            VERSION: this.VERSION,
            AUTHOR: this.AUTHOR,
            LICENSE: this.LICENSE,
            REPOSITORY: this.REPOSITORY,
            HOMEPAGE: this.HOMEPAGE,
        };
    }
}
//# sourceMappingURL=info.js.map